import React from "react";

const AssetModal = ({
  isOpen,
  isEditing,
  newProduct,
  setNewProduct,
  errorMessage,
  isLoading,
  loadingMessage,
  onClose,
  onSubmit,
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center px-4">
        {/* Modal Container */}
        <div className="bg-white w-full max-w-lg rounded-lg shadow-lg p-6 relative">
          {/* Close Button */}
          <button
            className="absolute top-3 right-3 text-gray-500 hover:text-red-500 text-2xl font-bold"
            onClick={onClose}
            disabled={isLoading}
          >
            ×
          </button>

          {/* Modal Header */}
          <h2 className="text-xl font-semibold mb-4 text-center">
            {isEditing ? "Edit Asset" : "Add New Asset"}
          </h2>

          {/* Error Message */}
          {errorMessage && (
            <p className="text-red-600 text-sm mb-2 text-center">
              {errorMessage}
            </p>
          )}

          {/* Form Fields */}
          <div className="space-y-4">
            <label className="block">
              <span className="text-sm font-medium">Iridis ID Number:</span>
              <input
                type="text"
                value={newProduct.iridis_id}
                onChange={(e) =>
                  setNewProduct({ ...newProduct, iridis_id: e.target.value })
                }
                disabled={isLoading}
                placeholder="Enter Iridis ID"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
              />
            </label>

            <label className="block">
              <span className="text-sm font-medium">Item:</span>
              <input
                type="text"
                value={newProduct.asset_name}
                onChange={(e) =>
                  setNewProduct({ ...newProduct, asset_name: e.target.value })
                }
                disabled={isLoading}
                placeholder="Enter Asset Name"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
              />
            </label>

            <label className="block">
              <span className="text-sm font-medium">Serial No:</span>
              <input
                type="text"
                value={newProduct.serial_number}
                onChange={(e) =>
                  setNewProduct({
                    ...newProduct,
                    serial_number: e.target.value,
                  })
                }
                disabled={isLoading}
                placeholder="Enter Serial Number"
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
              />
            </label>

            <label className="block">
              <span className="text-sm font-medium">Location:</span>
              <select
                value={newProduct.asset_location}
                onChange={(e) =>
                  setNewProduct({
                    ...newProduct,
                    asset_location: e.target.value,
                  })
                }
                disabled={isLoading}
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
              >
                <option value="" disabled>
                  Select location
                </option>
                <option value="Business Office">Business Office</option>
                <option value="Conference Office">Conference Office</option>
                <option value="Lobby">Lobby</option>
                <option value="Waiting Area">Waiting Area</option>
                <option value="Tech Lab">Tech Lab</option>
                <option value="Developers' Office">Developers' Office</option>
                <option value="Executive Office">Executive Office</option>
                <option value="Staff Conference Room">
                  Staff Conference Room
                </option>
                <option value="Kitchen">Kitchen</option>
                <option value="Gravel Garden">Gravel Garden</option>
                <option value="Security Post">Security Post</option>
                <option value="Cloud">Cloud</option>
              </select>
            </label>

            <label className="block">
              <span className="text-sm font-medium">Product Type:</span>
              <select
                value={newProduct.asset_type}
                onChange={(e) =>
                  setNewProduct({
                    ...newProduct,
                    asset_type: e.target.value,
                  })
                }
                disabled={isLoading}
                className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
              >
                <option value="fixed">Fixed</option>
                <option value="current">Current</option>
                <option value="intangible">Intangible</option>
                <option value="inventory">Inventory</option>
              </select>
            </label>
          </div>

          {/* Submit Button */}
          <button
            className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded font-medium disabled:opacity-50"
            onClick={onSubmit}
            disabled={isLoading}
          >
            {isEditing ? "Update Asset" : "Add Asset"}
          </button>
        </div>
      </div>

      {/* Loading Overlay */}
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg px-6 py-4 flex flex-col items-center shadow-lg">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-blue-500 border-solid mb-2"></div>
            <p className="text-sm text-gray-600">{loadingMessage}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default AssetModal;
